import { useTranslation } from "react-i18next";
import { css } from "@filadd/phi-plus-styled-system/css";
import { CollapsibleCard } from "@filadd/phi-plus-core";

import { useBlockPivotsByCourse } from "hooks/courses-new/block";

import { PendingDiagnostic } from "./PendingDiagnostic";

interface Props {
  courseSlug: string;
}

export const UserPendingDiagnostic = ({ courseSlug }: Props) => {
  const { t } = useTranslation();
  const {
    data: blockPivots,
    isLoading,
    isSuccess,
  } = useBlockPivotsByCourse({
    params: {
      field: "slug",
      value: courseSlug,
      diagnostic: true,
      expands: ["program_unit_pivot"],
    },
  });

  if (isLoading || !isSuccess || !blockPivots.length) {
    return null;
  }

  return (
    <CollapsibleCard
      header={<h2>{t("pendingDiagnostic:title")}</h2>}
      className={css({
        borderRadius: "xl",
        bgColor: "primary",
        color: "white",
        boxShadow: "md",

        "& .collapsible_card__header": {
          color: "white",
        },
      })}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: 1,
        })}
      >
        {blockPivots.map(
          ({ short_slug, title: blockTitle, program_unit_pivot }) =>
            program_unit_pivot ? (
              <PendingDiagnostic
                key={short_slug}
                title={blockTitle}
                courseSlug={courseSlug}
                programUnitShortSlug={program_unit_pivot.short_slug}
                blocksShortSlug={short_slug}
              />
            ) : null,
        )}
      </div>
    </CollapsibleCard>
  );
};
